import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TOOLS } from "../data/tools.js";
import { PLAYBOOK_POSTS } from "../data/playbook.js";
import { readWorkspace } from "../lib/workspace.js";
import BanDoLoTrinh from "../components/BanDoLoTrinh.jsx";
import { SO_TRAM } from "../data/lo-trinh.js";
import HoSoDong from "../components/HoSoDong.jsx";
import TheViecLuoi from "../components/TheViecLuoi.jsx";
import HangQuet from "../components/HangQuet.jsx";
import SoLieuNhanh from "../components/SoLieuNhanh.jsx";
import TheDiemMau from "../components/TheDiemMau.jsx";
import NoiDauGoiVon from "../components/NoiDauGoiVon.jsx";
import CamKetMinhBach from "../components/CamKetMinhBach.jsx";

export const urlCongCu = (id) => "/cong-cu/" + TOOLS.find((t) => t.toolId === id).slug;

/**
 * "Tiếp tục công việc gần nhất" — chỉ hiện khi trình duyệt đã có bản nháp.
 * Đọc sau khi trang chạy trên máy người dùng: HTML render sẵn cho Google không
 * có khối này, nên không lệch khi hydrate.
 */
function TiepTuc() {
  const [gan, setGan] = useState(null);
  useEffect(() => {
    try {
      const d = readWorkspace();
      const nhap = Object.entries(d.drafts || {})
        .map(([id, v]) => ({ id, updated: v?.updated || "", tool: TOOLS.find((t) => t.toolId === id) }))
        .filter((x) => x.tool)
        .sort((a, b) => (a.updated < b.updated ? 1 : -1));
      const soNguon = (d.saved || []).length;
      if (nhap.length || soNguon) setGan({ nhap: nhap[0] || null, soNhap: nhap.length, soNguon });
    } catch {
      /* bộ nhớ trình duyệt bị chặn: không hiện gì */
    }
  }, []);
  if (!gan) return null;
  return (
    <div className="tiep-tuc surface" role="region" aria-label="Tiếp tục công việc">
      <div>
        <p className="eyebrow">TIẾP TỤC CÔNG VIỆC GẦN NHẤT</p>
        {gan.nhap ? (
          <p>
            <strong>{gan.nhap.tool.title}</strong>
            {gan.nhap.updated && (
              <span className="muted">, lưu {new Date(gan.nhap.updated).toLocaleDateString("vi-VN")}</span>
            )}
          </p>
        ) : (
          <p>Bạn đã lưu {gan.soNguon} nguồn vốn quan tâm.</p>
        )}
      </div>
      <div className="hang-nut">
        {gan.nhap && (
          <Link className="nut" to={urlCongCu(gan.nhap.id)}>
            Mở lại →
          </Link>
        )}
        <Link className="nut phu" to="/ban-chuan-bi">
          Bản chuẩn bị của tôi
        </Link>
      </div>
    </div>
  );
}

/**
 * Hình kết quả mẫu trên mỗi thẻ: cho người mới thấy mình sẽ mang về thứ gì.
 * Số trong hình là VÍ DỤ, giống khung động ở đầu trang.
 */
const HINH_THE = {
  funds: (
    <>
      {[["92%", 60, 1], ["85%", 48, 1], ["chưa khớp", 54, 0]].map(([nhan, dai, khop], i) => (
        <g key={nhan} opacity={khop ? 1 : 0.55}>
          <rect x="6" y={6 + i * 22} width="138" height="17" rx="4" className="ht-vien" />
          <circle cx="16" cy={14.5 + i * 22} r="4" className={khop ? "ht-la" : "ht-mo"} />
          <path d={`M26 ${14.5 + i * 22}h${dai}`} className="ht-net" />
          <text x="138" y={18 + i * 22} textAnchor="end" className={khop ? "ht-chu" : "ht-chu-nho"}>{nhan}</text>
        </g>
      ))}
    </>
  ),
  capital: (
    <>
      <text x="8" y="16" className="ht-chu-nho">Tiền còn đủ dùng</text>
      <rect x="8" y="24" width="134" height="16" rx="4" className="ht-vien" />
      <rect x="8" y="24" width="82" height="16" rx="4" className="ht-muc" />
      <path d="M90 20v24" className="ht-moc" />
      <text x="8" y="60" className="ht-chu ht-lon">11 tháng</text>
      <text x="142" y="60" textAnchor="end" className="ht-chu-nho">cần gọi 4,2 tỷ</text>
    </>
  ),
  docs: (
    <>
      <rect x="8" y="8" width="84" height="56" rx="4" className="ht-vien" />
      <path d="M18 52l14-14 10 7 20-20 18 4" className="ht-duong" />
      <circle cx="120" cy="36" r="22" className="ht-vong-nen" />
      <circle cx="120" cy="36" r="22" className="ht-vong" strokeDasharray="96.8 138.2" transform="rotate(-90 120 36)" />
      <text x="120" y="40" textAnchor="middle" className="ht-chu">7/10</text>
    </>
  ),
  ready: (
    <>
      <path d="M35 62a40 40 0 0 1 80 0" className="ht-cung-nen" />
      <path d="M35 62a40 40 0 0 1 64 -32" className="ht-cung" />
      <text x="75" y="58" textAnchor="middle" className="ht-chu ht-lon">62</text>
      <text x="75" y="69" textAnchor="middle" className="ht-chu-nho">/100 sẵn sàng</text>
    </>
  ),
};

export function TheHanhTrinh({ j }) {
  // Không bọc cả thẻ trong một liên kết: liên kết lồng nhau không hợp lệ, và
  // người dùng cần chọn đúng câu hỏi. Một hành động chính, còn lại là chữ nhỏ.
  const [chinh, ...phu] = j.links?.length ? j.links : [{ label: j.title, tool: j.tool }];
  return (
    <article className={`the-viec${j.noiBat ? " noi-bat" : ""}`}>
      {HINH_THE[j.id] && (
        <div className="the-viec-hinh" aria-hidden="true">
          <svg viewBox="0 0 150 72">{HINH_THE[j.id]}</svg>
        </div>
      )}
      <span className="the-viec-so">{j.number}{j.noiBat ? " · Nên bắt đầu ở đây" : ""}</span>
      <h3>{j.title}</h3>
      <p>{j.desc}</p>
      <Link className="the-viec-chinh" to={chinh.to || urlCongCu(chinh.tool)}>
        {chinh.label} <span aria-hidden="true">→</span>
      </Link>
      {phu.length > 0 && (
        <ul className="the-viec-phu">
          {phu.map((l) => (
            <li key={l.label}><Link to={l.to || urlCongCu(l.tool)}>{l.label}</Link></li>
          ))}
        </ul>
      )}
    </article>
  );
}

/** Ba bài Playbook để người mới thấy nội dung thực hành, không chỉ công cụ. */
function PlaybookNoiBat() {
  const bai = [...PLAYBOOK_POSTS].sort((a, b) => Number(Boolean(b.featured)) - Number(Boolean(a.featured))).slice(0, 3);
  if (!bai.length) return null;
  return (
    <section className="section-space" aria-labelledby="playbook-trang-chu">
      <div className="section-bar">
        <h2 id="playbook-trang-chu">Đọc trước khi gặp nhà đầu tư</h2>
        <p><Link to="/playbook">Tất cả Playbook →</Link></p>
      </div>
      <HangQuet className="home-playbook">
        {bai.map((p) => (
          <Link className="home-playbook-card" to={`/playbook/${p.slug}`} key={p.slug}>
            <span className="eyebrow">{p.category}</span>
            <strong>{p.title}</strong>
            <span className="muted">{p.excerpt}</span>
            <span className="card-link">{p.readingMinutes} phút đọc →</span>
          </Link>
        ))}
      </HangQuet>
    </section>
  );
}

export default function Home() {
  return (
    <>
      {/* Mở đầu kiểu YC (10/2026): một câu lớn, một chú thích giải nghĩa,
          một nút chính và ba lối vào theo tình huống. Chữ trong h1 giữ như
          bản trước để không xáo trộn SEO. */}
      <section className="hm-mo-dau" id="bat-dau" aria-labelledby="hm-tieu-de">
        <p className="hm-nhan">Dành cho người gọi vốn lần đầu</p>
        <h1 id="hm-tieu-de">
          Vững bước hơn trước vòng <em>gọi vốn</em>
        </h1>
        <p className="hm-chu-thich">
          <b>[1]</b>Vững bước nghĩa là hiểu con số của mình, có đủ hồ sơ nhà đầu tư sẽ hỏi, và luôn biết bước tiếp theo là gì.
        </p>
        <div className="hm-cta">
          <Link className="nut" to={urlCongCu("readiness-score")}>Bắt đầu hồ sơ của bạn</Link>
          <Link to="/lo-trinh">Xem lộ trình {SO_TRAM} trạm →</Link>
        </div>
        <div className="trust">
          <span>Miễn phí</span>
          <span>Không cần tài khoản</span>
          <span>Số liệu tính trên máy bạn</span>
        </div>
        {/* Thẻ điểm mẫu: thấy ngay kết quả mình sẽ mang về (27/10/2026). */}
        <TheDiemMau to={urlCongCu("readiness-score")} />
        <nav className="hm-loi-vao" aria-label="Chọn tình huống của bạn">
          <Link to="/bat-dau">
            <span>Mới bắt đầu</span>
            <strong>Chưa biết gọi vốn bắt đầu từ đâu</strong>
            <small>Đi qua từng câu nhà đầu tư sẽ hỏi, bước đầu chừng 3 phút.</small>
            <i>Bắt đầu →</i>
          </Link>
          <Link to="/nhan-xet-deck">
            <span>Sắp gặp nhà đầu tư</span>
            <strong>Muốn deck được người khác đọc trước</strong>
            <small>Gửi PDF, nhận nhận xét từng slide sau 15 đến 30 phút.</small>
            <i>Gửi deck →</i>
          </Link>
          <Link to="/nguon-von">
            <span>Đang tìm vốn</span>
            <strong>Cần biết quỹ nào đang nhận hồ sơ</strong>
            <small>Quỹ và chương trình kèm tiêu chí, nguồn chính thức.</small>
            <i>Xem nguồn vốn →</i>
          </Link>
        </nav>
      </section>

      <NoiDauGoiVon />

      {/* Khung động: cho thấy site làm gì mà không cần đọc. */}
      <section className="home-hero hm-may section-space" aria-labelledby="hm-cach-lam">
        <div className="home-hero-dau">
          <p className="eyebrow">CÁCH LÀM</p>
          <h2 id="hm-cach-lam">Trả lời từng câu, hồ sơ gọi vốn tự thành hình</h2>
          <p className="lead">Mỗi công cụ hỏi đúng điều nhà đầu tư sẽ hỏi. Kết quả gom vào Bản chuẩn bị của bạn để dùng lại khi viết deck.</p>
        </div>
        <HoSoDong cta={{ to: urlCongCu("readiness-score"), nhan: "Bắt đầu hồ sơ của bạn" }} />
        <SoLieuNhanh />
      </section>

      <section className="home-viec" aria-labelledby="home-viec-tieu-de">
        <h2 id="home-viec-tieu-de">Hôm nay, bạn muốn giải quyết việc gì?</h2>
        <TheViecLuoi renderThe={(j) => <TheHanhTrinh j={j} key={j.id} />} />
      </section>

      {/* Bản đồ: cho thấy mỗi trạm mang về kết quả gì, và sáng theo tiến độ thật. */}
      <section className="home-ban-do section-space" aria-labelledby="ban-do-trang-chu">
        <div className="section-bar">
          <h2 id="ban-do-trang-chu">Gọi vốn lần đầu đi qua {SO_TRAM} trạm</h2>
          <p><Link to="/lo-trinh">Xem lộ trình chi tiết →</Link></p>
        </div>
        <BanDoLoTrinh />
      </section>
      <CamKetMinhBach />
      <PlaybookNoiBat />
      {/* Người đã dùng site: tiếp tục việc dang dở. Đặt cuối trang để không chen
          vào phần giới thiệu dành cho người mới. */}
      <div className="home-tiep-tuc"><TiepTuc /></div>
    </>
  );
}
